/* Spanischer Sprachkatalog. Schlüssel ist der deutsche Quelltext. */

const texte = {
  "Rot": "Tinto",
  "Weiß": "Blanco",
  "Rosé": "Rosado",
  "Schaumwein": "Espumoso",
  "Edelsüß": "Dulce noble",
  "Orange": "Naranja",
  "Gespritet": "Fortificado",
  "100-Punkte-Skala": "Escala de 100 puntos",
  "20-Punkte-Skala": "Escala de 20 puntos",
  "5-Sterne-Skala": "Escala de 5 estrellas",
  "Prozent-Skala": "Escala porcentual",
  "0,375 l · Halbe Flasche": "0,375 l · Media botella",
  "0,5 l · Süßweinflasche": "0,5 l · Vino dulce",
  "0,75 l · Standard": "0,75 l · Estándar",
  "1,5 l · Magnum": "1,5 l · Mágnum",
  "3 l · Doppelmagnum": "3 l · Doble mágnum",
  "6 l · Imperial": "6 l · Imperial",
  "Name A–Z": "Nombre A–Z",
  "Name Z–A": "Nombre Z–A",
  "Jahrgang jung–alt": "Añada, más reciente primero",
  "Jahrgang alt–jung": "Añada, más antigua primero",
  "Jahrgang, neueste zuerst": "Añada, más reciente primero",
  "Jahrgang, älteste zuerst": "Añada, más antigua primero",
  "Preis hoch–niedrig": "Precio, de mayor a menor",
  "Preis niedrig–hoch": "Precio, de menor a mayor",
  "Preis aufsteigend": "Precio, de menor a mayor",
  "Preis absteigend": "Precio, de mayor a menor",
  "Bewertung hoch–niedrig": "Puntuación, de mayor a menor",
  "Bewertung niedrig–hoch": "Puntuación, de menor a mayor",
  "Bestand, meiste zuerst": "Existencias, mayor primero",
  "Jede Trinkreife": "Cualquier momento",
  "Noch nicht trinkreif": "Aún no listo",
  "Trinkreif": "Listo para beber",
  "Überfällig": "Pasado",
  "Weinkarte": "Carta de vinos",
  "Weinkeller": "Bodega",
  "Keller": "Bodega",
  "Weine": "Vinos",
  "Winzer": "Bodegas",
  "Regionen": "Regiones",
  "Karte": "Carta",
  "Filter": "Filtros",
  "Sortierung": "Orden",
  "Zurücksetzen": "Restablecer",
  "Zurück": "Atrás",
  "Nur ansehen": "Solo lectura",
  "Wird geladen …": "Cargando …",
  "Alle Typen": "Todos los tipos",
  "Alle Jahrgänge": "Todas las añadas",
  "Alle Länder": "Todos los países",
  "Alle Regionen": "Todas las regiones",
  "Alle Winzer": "Todas las bodegas",
  "Alle Rebsorten": "Todas las variedades",
  "Alle Labels": "Todas las etiquetas",
  "andere Suche": "otra búsqueda",
  "Für diesen Winzer sind noch keine Weine im Katalog.": "Todavía no hay vinos de este productor en el catálogo.",
  "Ein Wein dieses Winzers im Katalog:": "Un vino de este productor en el catálogo:",
  "{n} Weine dieses Winzers im Katalog:": "{n} vinos de este productor en el catálogo:",
  "Eigenen Wein dieses Winzers anlegen": "Crear un vino propio de este productor",
  "Aus dem Katalog": "Del catálogo",
  "Eigener Jahrgang": "Añada propia",
  "Kritiken": "Críticas",
  "Witterung": "Clima",
  "Ohne Winzer": "Sin bodega",
  "Ohne Region": "Sin región",
  "Ohne Land": "Sin país",
  "Diese Weinkarte ist noch leer.": "Esta carta de vinos aún está vacía.",
  "Geteilt über WineLake · schreibgeschützte Ansicht": "Compartido con WineLake · solo lectura",
  "Keine Flaschen im Bestand.": "No hay botellas en existencias.",
  "Keine Positionen gefunden.": "No se encontraron entradas.",
  "Keine Regionen gefunden.": "No se encontraron regiones.",
  "Keine Weine gefunden.": "No se encontraron vinos.",
  "Keine Winzer gefunden.": "No se encontraron bodegas.",
  "Weine auf dieser Karte": "Vinos de esta carta",
  "Der Server ist nicht erreichbar.": "No se puede acceder al servidor.",
  "Diese Freigabe ist nicht verfügbar.": "Este enlace no está disponible.",
  "Etikett vergrößern": "Ampliar etiqueta",
  "Etikett": "Etiqueta",
  "Mittel": "Media",
  "Wärmesumme": "Suma térmica",
  "Niederschlag": "Precipitación",
  "Sonne": "Sol",
  "Hitzetage": "Días de calor",
  "Frosttage": "Días de helada",
  "Verkostung": "Cata",
  "Wein": "Vino",
  "Vegetationsperiode {zeitraum}": "Periodo vegetativo {zeitraum}",
  "Trinkfenster {von}–{bis}": "Ventana de consumo {von}–{bis}",
  "Zurück zu Winzern": "Volver a bodegas",
  "Zurück zu Regionen": "Volver a regiones",
  "{n} Fl.": "{n} bot.",
  "ein Wein": "1 vino",
  "{n} Weine": "{n} vinos",
  "Rückmeldung": "Comentarios",
  "Fehler gefunden, etwas vermisst oder eine Idee? Schreib mir gern — jede Rückmeldung hilft.": "¿Has encontrado un fallo, echas algo en falta o tienes una idea? Escríbeme, cada mensaje ayuda.",
  "Einführung": "Introducción",
  "Ein Überblick über die wichtigsten Funktionen. Die Abschnitte lassen sich einzeln aufklappen.": "Un resumen de las funciones principales. Cada sección se abre por separado.",
  "{n} Wein": "{n} vino",
  "{n} Position": "{n} posición",
  "{n} Positionen": "{n} posiciones",
  "Sprache der Karte": "Idioma de la carta",
  "Automatisch (Sprache des Gastes)": "Automático (idioma del visitante)",
  "Aktualisieren": "Actualizar",
  "Statistik": "Estadísticas",
  "Nur mit Bestand": "Solo con existencias",
  "Mein Konto": "Mi cuenta",
  "Teilen": "Compartir",
  "Katalog": "Catálogo",
  "Daten": "Datos",
  "Verwaltung": "Administración",
  "Menü": "Menú",
  "Datenstand": "Estado de datos",
  "Datenhaltung": "Almacenamiento",
  "Abmelden": "Cerrar sesión",
  "Keller löschen": "Eliminar bodega",
  "E-Mail & Passwort": "Correo y contraseña",
  "Keller teilen": "Compartir bodega",
  "Weinkarten": "Cartas de vinos",
  "Änderungen": "Cambios",
  "Meine Vorschläge": "Mis propuestas",
  "Vorschläge prüfen": "Revisar propuestas",
  "Zusammenführen": "Fusionar duplicados",
  "Wetterdaten laden": "Cargar datos del clima",
  "Excel exportieren": "Exportar a Excel",
  "Excel importieren": "Importar desde Excel",
  "Leere Vorlage": "Plantilla vacía",
  "Cloud": "Nube",
  "Lokal": "Local",
  "Admin": "Admin",
  "Wird gespeichert …": "Guardando …",
  "Prüfe …": "Comprobando …",
  "Offline — lokal gesichert": "Sin conexión — guardado localmente",
  "Synchronisiert · Stand {v}": "Sincronizado · versión {v}",
  "Stammdaten aus dem gemeinsamen Katalog übernehmen.": "Adoptar datos maestros del catálogo compartido.",
  "Nur deine eigenen Daten, kein Katalog.": "Solo tus datos, sin catálogo.",
  "Die Katalog-Synchronisation wurde für dieses Konto abgeschaltet. Deine eigenen Daten bleiben nutzbar.": "La sincronización del catálogo está desactivada para esta cuenta. Tus datos siguen disponibles.",
  "Sprache": "Idioma",
  "Jahrgang": "Añada",
  "Typ": "Tipo",
  "Region": "Región",
  "Land": "País",
  "Bestand": "Existencias",
  "Flaschen": "Botellas",
  "Positionen": "Entradas",
  "Preis": "Precio",
  "Lager": "Almacén",
  "Kritik": "Puntuación",
  "Kellerwert": "Valor de la bodega",
  "Wein anlegen": "Añadir vino",
  "Keller durchsuchen …": "Buscar en la bodega …",
  "Lieblingswein": "Favorito",
  "Keine Positionen gefunden. Lege einen Wein an oder passe Suche und Filter an.": "No se encontraron entradas. Añade un vino o ajusta la búsqueda y los filtros.",
  "Alle Weine": "Todos los vinos",
  "Nur Lieblingsweine": "Solo favoritos",
  "Alle Lagerorte": "Todos los almacenes",
  "Filter zurücksetzen": "Restablecer filtros",
  "Bestand hoch–niedrig": "Existencias, mayor a menor",
  "Bestand niedrig–hoch": "Existencias, menor a mayor",
  "Trinkreife alt–jung": "Consumo, más antiguo primero",
  "Trinkreife jung–alt": "Consumo, más reciente primero",
  "Bearbeiten": "Editar",
  "Öffnen": "Abrir",
  "Zur Weinliste": "A la lista de vinos",
  "Zum Wein": "Al vino",
  "Zur Winzerliste": "A la lista de bodegas",
  "Zu den Regionen": "A las regiones",
  "Zurück zu den Ländern": "Volver a los países",
  "Im Keller zeigen": "Ver en la bodega",
  "Jahrgänge": "Añadas",
  "Winzer anlegen": "Añadir bodega",
  "Region anlegen": "Añadir región",
  "Jahrgang anlegen": "Añadir añada",
  "Kritik erfassen": "Añadir puntuación",
  "Wein löschen": "Eliminar vino",
  "Winzer löschen": "Eliminar bodega",
  "Region löschen": "Eliminar región",
  "Jahrgang löschen": "Eliminar añada",
  "Entfernen": "Quitar",
  "Vergrößern": "Ampliar",
  "Bewertung": "Puntuación",
  "Kritiker / Quelle": "Crítico / fuente",
  "Anlass / Pairing": "Ocasión / maridaje",
  "Notiz": "Nota",
  "Trinkfenster": "Ventana de consumo",
  "Ein- & Auslagerungen": "Movimientos",
  "Eingelagert": "Ingresado",
  "Entnommen": "Retirado",
  "Auf Weinkarte": "En la carta",

  /* Trinkverlauf */
  "Trinkverlauf": "Historial de bodega",
  "Einlagerungen": "Entradas",
  "Entnahmen": "Salidas",
  "Art der Bewegung": "Tipo de movimiento",
  "Alle Jahre": "Todos los años",
  "Jahr": "Año",
  "Suchen": "Buscar",
  "Wein, Winzer, Händler …": "Vino, bodeguero, distribuidor …",
  "eingelagert": "ingresado",
  "ausgelagert": "retirado",
  "Saldo": "Saldo",
  "Jg.": "Añada",
  "Ohne Datum": "Sin fecha",
  "Unbekannter Wein": "Vino desconocido",
  "Zu dieser Auswahl gibt es keine Bewegungen.": "No hay movimientos para esta selección.",
  "Noch keine Ein- oder Auslagerungen erfasst. Sobald du Flaschen einlagerst oder entnimmst, entsteht hier der Verlauf.": "Todavía no hay movimientos registrados. En cuanto ingreses o retires botellas, aquí aparecerá el historial.",
  "Alk.": "Alc.",
  "Säure": "Acidez",
  "Ausbau": "Crianza",
  "Geschmack": "Sabor",
  "Boden": "Suelo",
  "Dieser Wein existiert nicht mehr.": "Este vino ya no existe.",
  "Kein Jahrgang dieses Weins hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "Ninguna añada de este vino tiene existencias. Desactiva «Solo con existencias» para ver todas.",
  "Noch kein Jahrgang erfasst. Lege den ersten Jahrgang mit Analysewerten und Anfangsbestand an.": "Aún no hay añadas. Añade la primera con valores analíticos y existencias iniciales.",
  "Noch keine Kritiken erfasst.": "Aún no hay críticas.",
  "Analyse & Kellerdaten": "Análisis y datos de bodega",
  "Alkohol": "Alcohol",
  "Restzucker": "Azúcar residual",
  "Schwefel": "Azufre",
  "Zuckerkategorie": "Categoría de dulzor",
  "Reife": "Madurez",
  "Verschluss": "Cierre",
  "Kapsel": "Cápsula",
  "Lagerort": "Lugar de almacenaje",
  "Preis (Flasche)": "Precio (botella)",
  "Ø Einstand": "Ø precio de coste",
  "Flaschen im Bestand": "Botellas en existencias",
  "Bezugsquellen": "Proveedores",
  "Zugang": "Entrada",
  "Entnehmen": "Retirar",
  "Neu aufnehmen": "Añadir nuevo",
  "Etikettenfoto hinzufügen": "Añadir foto de etiqueta",
  "Bild wählen": "Elegir imagen",
  "Wird hochgeladen …": "Subiendo …",
  "Dieser Jahrgang existiert nicht mehr.": "Esta añada ya no existe.",
  "Für diesen Jahrgang ist noch keine Kritik erfasst.": "Aún no hay puntuación para esta añada.",
  "Für Weine ohne Jahrgang (N.V.) gibt es keine jahresbezogene Witterung.": "Los vinos sin añada (N.V.) no tienen datos meteorológicos por año.",
  "Ort": "Localidad",
  "Rebsorten": "Variedades",
  "Winzer durchsuchen …": "Buscar bodegas …",
  "Nach Land filtern": "Filtrar por país",
  "Nach Region filtern": "Filtrar por región",
  "Nach Rebsorte filtern": "Filtrar por variedad",
  "Nach Label filtern": "Filtrar por etiqueta",
  "Dieser Winzer existiert nicht mehr.": "Esta bodega ya no existe.",
  "Für diesen Winzer ist noch kein Wein erfasst.": "Aún no hay vinos de esta bodega.",
  "Kein Wein dieses Winzers hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "Ningún vino de esta bodega tiene existencias. Desactiva «Solo con existencias» para ver todos.",
  "Keine Winzer gefunden. Lege einen Winzer an oder passe Suche und Filter an.": "No se encontraron bodegas. Añade una o ajusta la búsqueda y los filtros.",
  "Zuerst die Weine dieses Winzers löschen oder umziehen.": "Primero elimina o traslada los vinos de esta bodega.",
  "Alle": "Todos",
  "Appellation": "Denominación",
  "Appellationen": "Denominaciones",
  "Koordinaten": "Coordenadas",
  "Weine dieser Region": "Vinos de esta región",
  "Weinen": "vinos",
  "Länder & Regionen durchsuchen …": "Buscar países y regiones …",
  "Diese Region existiert nicht mehr.": "Esta región ya no existe.",
  "Aus dieser Region ist noch kein Wein erfasst.": "Aún no hay vinos de esta región.",
  "Noch keine Beschreibung hinterlegt.": "Aún sin descripción.",
  "Noch keine Winzer in dieser Region.": "Aún no hay bodegas en esta región.",
  "Kein Land gefunden. Passe Suche und Filter an oder lege eine Region an.": "No se encontró ningún país. Ajusta la búsqueda o añade una región.",
  "Keine Region gefunden — Suche und Filter anpassen oder eine Region anlegen.": "No se encontró ninguna región: ajusta la búsqueda o añade una.",
  "Keine Region gefunden. Passe die Suche an oder lege eine Region an.": "No se encontró ninguna región. Ajusta la búsqueda o añade una.",
  "Kein Wein dieser Region hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "Ningún vino de esta región tiene existencias. Desactiva «Solo con existencias» para ver todos.",
  "Zuerst die Winzer dieser Region löschen oder umziehen.": "Primero elimina o traslada las bodegas de esta región.",
  "Abbrechen": "Cancelar",
  "Schließen": "Cerrar",
  "Löschen": "Eliminar",
  "Anlegen": "Crear",
  "Speichern": "Guardar",
  "Auswählen …": "Seleccionar …",
  "Wählen …": "Elegir …",
  "Name": "Nombre",
  "Datum": "Fecha",
  "Menge": "Cantidad",
  "Größe": "Tamaño",
  "Fl.": "bot.",
  "Quelle": "Fuente",
  "Ziel": "Destino",
  "Stand": "Versión",
  "Zuletzt": "Última vez",
  "Offen": "Abierta",
  "Gesperrt": "Cerrada",
  "Wetter": "Clima",
  "Benutzername": "Usuario",
  "Registriert": "Registrado",
  "Registrierung": "Registro",
  "E-Mail": "Correo",
  "Passwort ändern": "Cambiar contraseña",
  "Bisheriges Passwort": "Contraseña actual",
  "Neues Passwort": "Nueva contraseña",
  "Neues Passwort wiederholen": "Repetir nueva contraseña",
  "Neues Passwort setzen": "Establecer nueva contraseña",
  "E-Mail oder Benutzername": "Correo o usuario",
  "Zur Anmeldung": "Ir al inicio de sesión",
  "Jetzt anmelden": "Iniciar sesión",
  "Link wird geprüft …": "Comprobando enlace …",
  "Konto löschen": "Eliminar cuenta",
  "Weintyp": "Tipo de vino",
  "Alkohol (% vol)": "Alcohol (% vol)",
  "Säure (g/l)": "Acidez (g/l)",
  "Restzucker (g/l)": "Azúcar residual (g/l)",
  "Trinkfenster von": "Consumo desde",
  "Trinkfenster bis": "Consumo hasta",
  "Flaschengröße": "Tamaño de botella",
  "Anfangsbestand (0,75-l-Flaschen)": "Existencias iniciales (botellas de 0,75 l)",
  "Kaufpreis je Flasche (€)": "Precio de compra por botella (€)",
  "Kaufdatum": "Fecha de compra",
  "Bezugsquelle": "Proveedor",
  "Zugang buchen": "Registrar entrada",
  "Verkostungsnotiz": "Nota de cata",
  "Bewertungsschema": "Escala",
  "Anlass": "Ocasión",
  "Speisenbegleitung (Pairing)": "Maridaje",
  "Kritik speichern": "Guardar puntuación",
  "Der Zugang wird dem Bestand der gewählten Flaschengröße gutgeschrieben. Bezugsquelle und Kaufpreis fließen in die Kaufhistorie ein.": "La entrada se acredita a las existencias del formato elegido. El proveedor y el precio se registran en el historial de compras.",
  "Nach der Entnahme kannst du direkt eine Verkostungsnotiz zum Jahrgang erfassen.": "Tras retirar una botella puedes añadir una nota de cata de la añada.",
  "Für diesen Jahrgang ist kein Bestand vorhanden — buche zuerst einen Zugang.": "No hay existencias de esta añada: registra primero una entrada.",
  "Für diesen Wein existiert noch kein Jahrgang. Lege zuerst einen Jahrgang an, um Kritiken zu erfassen.": "Este vino aún no tiene añadas. Añade una para registrar puntuaciones.",
  "Neue Region": "Nueva región",
  "Neuer Winzer": "Nueva bodega",
  "Region suchen …": "Buscar región …",
  "Winzer suchen …": "Buscar bodega …",
  "Kurzbeschreibung": "Descripción breve",
  "Klassifikation": "Clasificación",
  "Wichtige Rebsorten": "Variedades principales",
  "Anteil in Prozent": "Proporción en porcentaje",
  "Rebsorte entfernen": "Quitar variedad",
  "Breitengrad": "Latitud",
  "Längengrad": "Longitud",
  "Titel der Weinkarte": "Título de la carta",
  "Titel der neuen Weinkarte": "Título de la nueva carta",
  "Sichtbare Angaben": "Datos visibles",
  "Diese Weinkarte teilen": "Compartir esta carta",
  "Widerrufen": "Revocar",
  "Preis (€)": "Precio (€)",
  "Preis (€ / Flasche)": "Precio (€ / botella)",
  "Wein aus dem Keller wählen …": "Elegir un vino de la bodega …",
  "Zurück in den Keller": "Devolver a la bodega",
  "Eine Flasche als ausgeschenkt buchen": "Registrar una botella servida",
  "Noch keine Flaschen auf dieser Karte.": "Aún no hay botellas en esta carta.",
  "Noch keine Weinkarten.": "Aún no hay cartas.",
  "Noch kein Freigabe-Link vorhanden.": "Aún no hay enlace para compartir.",
  "Im Keller liegen keine Flaschen, die sich auf eine Weinkarte setzen ließen.": "No hay botellas en la bodega para poner en una carta.",
  "Als PDF speichern / drucken": "Guardar como PDF / imprimir",
  "Annehmen": "Aceptar",
  "Ablehnen": "Rechazar",
  "Entschieden": "Decididas",
  "Zuletzt entschieden": "Decididas recientemente",
  "Keine offenen Vorschläge.": "No hay propuestas abiertas.",
  "Nichts offen.": "Nada pendiente.",
  "Katalogfassung übernehmen": "Adoptar versión del catálogo",
  "Noch keine Änderungen, die dich betreffen.": "Aún no hay cambios que te afecten.",
  "Bleibt bei dir erhalten und wird ab jetzt rein lokal geführt.": "Se conserva y a partir de ahora se gestiona solo localmente.",
  "Dieses Objekt wird bei dir lokal geführt und nicht mehr abgeglichen.": "Este elemento se gestiona localmente y ya no se sincroniza.",
  "Nur Jahrgänge oder Rebsorten betroffen.": "Solo afecta a añadas o variedades.",
  "Begründung (nur bei Ablehnung sinnvoll)": "Motivo (útil al rechazar)",
  "Mögliche Dubletten": "Posibles duplicados",
  "Vorschau": "Vista previa",
  "Richtung tauschen": "Invertir dirección",
  "Jetzt zusammenführen": "Fusionar ahora",
  "Im Katalog zusammenführen": "Fusionar en el catálogo",
  "Quelle — geht auf und verschwindet": "Origen: se fusiona y desaparece",
  "Quelle — verschwindet": "Origen: desaparece",
  "Ziel — bleibt bestehen": "Destino: se conserva",
  "Ziel — bleibt": "Destino: se conserva",
  "Quelle und Ziel müssen verschieden sein.": "El origen y el destino deben ser distintos.",
  "Hier gibt es noch nichts zusammenzuführen.": "Aún no hay nada que fusionar.",
  "Dieser Schritt kann nicht rückgängig gemacht werden.": "Este paso no se puede deshacer.",
  "Bereich": "Área",
  "Neu angelegt": "Creados",
  "Aktualisiert / verknüpft": "Actualizados / vinculados",
  "Übersprungen": "Omitidos",
  "Hinweise": "Avisos",
  "Betroffen": "Afectados",
  "Keine Konten vorhanden.": "No hay cuentas.",
  "Registrierung öffnen oder sperren": "Abrir o cerrar el registro",
  "Teilen & Weinkarten": "Compartir y cartas",
  "Wetterdaten für dieses Konto freischalten": "Habilitar datos del clima para esta cuenta",
  "Keller teilen und Weinkarten für dieses Konto freischalten": "Habilitar compartir y cartas para esta cuenta",
  "Nimmt dieses Konto am gemeinsamen Katalog teil? Abschalten stoppt Zulieferungen und Aktualisierungen.": "¿Participa esta cuenta en el catálogo compartido? Al desactivarlo se detienen aportaciones y actualizaciones.",
  "Alle aktualisieren": "Actualizar todo",
  "{n} Klimareihen vom Server": "{n} series climáticas del servidor",
  "bis zu {n} Jahrgänge vom Server": "hasta {n} añadas del servidor",
  "{n} Jahrgänge aus der Klimareihe, ohne Abruf": "{n} añadas a partir de la serie climática, sin consulta",
  "Die Wetterdaten werden geladen. Bitte das Fenster geöffnet lassen. Was schon geholt ist, liegt auch auf dem Server bereit.": "Se están cargando los datos meteorológicos. Mantenga la ventana abierta. Lo ya descargado queda también disponible en el servidor.",
  "Minutengrenze bei Open-Meteo erreicht — es geht in {n} s weiter.": "Se alcanzó el límite por minuto de Open-Meteo; se continúa en {n} s.",
  "Abgebrochen — das Kontingent bei Open-Meteo ist für den Moment erschöpft.": "Interrumpido: la cuota de Open-Meteo está agotada por ahora.",
  "Noch offen: {n}. Was schon geholt ist, bleibt erhalten — später erneut „Nur fehlende auffüllen“ wählen.": "Pendientes: {n}. Lo ya descargado se conserva; más tarde vuelva a elegir «Solo completar lo que falta».",
  "Nichts zu tun": "Nada que hacer",
  "Ohne Vegetationsdaten sind Jahrgänge, deren Saison noch nicht begonnen hat — das ist normal.": "Las añadas sin datos de temporada son aquellas cuya temporada aún no ha empezado; es normal.",
  "Letzter Fehler: {text}": "Último error: {text}",
  "Fertig. Fehlende Daten wurden aufgefüllt.": "Listo. Se han completado los datos que faltaban.",
  "Fertig. Alle Daten wurden aktualisiert.": "Listo. Se han actualizado todos los datos.",
  "Klimareihen geladen": "Series climáticas cargadas",
  "Jahrgänge vom Server": "Añadas del servidor",
  "Jahrgänge aus der Klimareihe": "Añadas de la serie climática",
  "Ohne Vegetationsdaten": "Sin datos de temporada",
  "Fehler": "Errores",
  "Klimareihen und Witterung für {r} Regionen und {j} Jahrgänge im Bestand.": "Series climáticas y meteorología para {r} regiones y {j} añadas en existencia.",
  "{n} Regionen ohne Koordinaten werden übersprungen.": "Se omiten {n} regiones sin coordenadas.",
  "{n} Klimareihen fehlt der jüngste abgeschlossene Jahrgang oder sein vollständiger Nachlauf.": "A {n} series climáticas les falta la última añada cerrada o su período posterior completo.",
  "Alles bereits vorhanden — nichts zu laden.": "Todo está ya disponible: nada que cargar.",
  "Der Server hält Klimareihen vorrätig; Open-Meteo wird nur für Fehlendes gefragt. Eine Region zum ersten Mal kostet dort viel Kontingent — wird es knapp, hält der Lauf an und sagt es.": "El servidor guarda las series climáticas; a Open-Meteo solo se le pide lo que falta. La primera carga de una región consume mucha cuota allí; si escasea, el proceso se detiene y lo indica.",
  "Nur fehlende auffüllen": "Solo completar lo que falta",
  "Erneut versuchen": "Intentar de nuevo",
  "Verstanden": "Entendido",
  "Lädt …": "Cargando …",
  "Übersicht wird geladen …": "Cargando resumen …",
  "Neu geladen": "Recargado",
  "Ohne verfügbare Daten": "Sin datos disponibles",
  "Foto nicht abrufbar": "Foto no disponible",
  "Standard (Name A–Z)": "Predeterminado (nombre A–Z)",
  "Die Excel-Datei wurde eingelesen und mit deinem Keller zusammengeführt.": "El archivo de Excel se ha leído y combinado con tu bodega.",
  "Die Wetterdaten werden von Open-Meteo geladen. Bitte das Fenster geöffnet lassen.": "Los datos del clima se cargan de Open-Meteo. Mantén esta ventana abierta.",
  "Einzelne Jahrgänge liefern keine Vegetationsdaten (z. B. sehr junge oder zukünftige Jahrgänge) — das ist normal.": "Algunas añadas no ofrecen datos vegetativos (muy recientes o futuras): es normal.",
  "+ Weitere Rebsorte": "+ Otra variedad",
  "Einen Moment …": "Un momento …",
  "Adresse aktualisieren": "Actualizar dirección",
  "Adresse speichern": "Guardar dirección",
  "Link anfordern": "Solicitar enlace",
  "Passwort setzen": "Establecer contraseña",
  "Anmelden": "Iniciar sesión",
  "Registrieren": "Registrarse",
  "Passwort": "Contraseña",
  "Passwort wiederholen": "Repetir contraseña",
  "Passwort vergessen?": "¿Olvidaste la contraseña?",
  "Einladungscode": "Código de invitación",
  "Anmeldung wird geprüft …": "Comprobando el acceso …",
  "Kellerbuch wird geöffnet …": "Abriendo el libro de bodega …",
  "Hauptnavigation": "Navegación principal",
  "Kontomodus": "Modo de cuenta",
  "Kellerbuch & Jahrgangsarchiv": "Libro de bodega y archivo de añadas",
  "WineLake · Witterung: Open-Meteo Historical Weather API · Karten: OpenStreetMap-Mitwirkende": "WineLake · Clima: Open-Meteo Historical Weather API · Mapas: colaboradores de OpenStreetMap",
  "Änderungen im Katalog": "Cambios del catálogo",
  "Katalog-Vorschläge": "Propuestas del catálogo",
  "Getrunken": "Consumido",
  "Aus Weinkarten": "De las cartas",
  "Wert": "Valor",
  "Einkauf": "Compra",
  "Verkauf": "Venta",
  "Gewinn": "Beneficio",
  "Kennzahl": "Métrica",
  "Kennzahlen im Vergleich": "Comparativa de métricas",
  "Alle Kalenderjahre": "Todos los años",
  "Alle Weinkarten": "Todas las cartas",
  "Nach Weinkarte filtern": "Filtrar por carta",
  "Nach Kalenderjahr der Bewegungen filtern": "Filtrar por año de los movimientos",
  "Auswertung nach Flaschen oder Wert": "Analizar por botellas o valor",
  "Ein- & Auslagerungen nach Jahren": "Movimientos por año",
  "Weltkarte des Kellers": "Mapa mundial de la bodega",
  "Weltkarte wird geladen …": "Cargando el mapa …",
  "Keine Positionen mit Koordinaten für diese Auswahl.": "No hay entradas con coordenadas para esta selección.",
  "Noch keine Daten.": "Aún no hay datos.",
  "Differenz": "Diferencia",
  "Aus dem Bewegungsprotokoll ab Aufzeichnungsbeginn — frühere Ein-/Auslagerungen sind nicht rekonstruierbar. Der Wert basiert auf dem hinterlegten Jahrgangspreis.": "Del registro de movimientos desde su inicio: los anteriores no se pueden reconstruir. El valor se basa en el precio de la añada.",
  "Witterungsprofil des Jahrgangs": "Perfil climático de la añada",
  "Jahrgang wählen": "Elegir añada",
  "Vergleichsjahr": "Año de comparación",
  "Vergleichsjahr wählen": "Elegir año de comparación",
  "Mit anderem Jahr vergleichen": "Comparar con otro año",
  "Lädt alle verfügbaren Jahre des Open-Meteo-Archivs in einem Abruf und berechnet die Mittelwerte.": "Carga todos los años disponibles del archivo Open-Meteo en una sola consulta y calcula las medias.",
  "Import abgeschlossen": "Importación completada",
  "Beenden": "Finalizar",
  "Weine durchsuchen …": "Buscar vinos …",
  "Einlagerung neu–alt": "Ingreso, más reciente primero",
  "Einlagerung alt–neu": "Ingreso, más antiguo primero",
  "Nach Weintyp": "Por tipo de vino",
  "Nach Zuckerkategorie": "Por categoría de dulzor",
  "Nach Ländern": "Por país",
  "Nach Regionen": "Por región",
  "Nach Rebsorten": "Por variedad",
  "Nach Winzern": "Por bodega",
  "Kellerbestand": "Existencias",
  "Weltkarte · {was}": "Mapa mundial · {was}",
  "Nach Weintyp filtern": "Filtrar por tipo de vino",
  "Nach Jahrgang filtern": "Filtrar por añada",
  "Nach Winzer filtern": "Filtrar por bodega",
  "Nach Lagerort filtern": "Filtrar por almacén",
  "Nach Trinkreife filtern": "Filtrar por madurez",
  "Nach Lieblingsweinen filtern": "Filtrar por favoritos",
  "Ohne Lagerort": "Sin almacén",
  "Keine Weine gefunden. Lege einen Wein an oder passe Suche und Filter an.": "No se encontraron vinos. Añade un vino o ajusta la búsqueda y los filtros.",
  "Länder": "Países",
  "Winzer & Weine": "Bodegas y vinos",
  "Regionen & Winzer": "Regiones y bodegas",
  "ein Winzer": "1 bodega",
  "{n} Winzer": "{n} bodegas",
  "eine Region": "1 región",
  "{n} Regionen": "{n} regiones",
  "eine Flasche": "1 botella",
  "{n} Flaschen": "{n} botellas",
  "Alle von {n} annehmen": "Aceptar todo de {n}",
  "Alle von {n} ablehnen": "Rechazar todo de {n}",
  "Ähnliche Einträge im Katalog": "Entradas similares en el catálogo",
  "Annehmen und zusammenführen": "Aceptar y fusionar",
  "Getrennt lassen": "Mantener separado",
  "Zusammenführen mit …": "Fusionar con …",
  "Bereits im Katalog": "Ya en el catálogo",
  "In {n} Kellern": "En {n} bodegas",
  "Ähnliche Einträge liegen schon im Katalog. Entscheide je Eintrag, ob zusammengeführt oder getrennt geführt wird — bis dahin wird nichts vorgeschlagen.": "Ya existen entradas similares en el catálogo. Decide en cada caso si fusionar o mantener separado; hasta entonces no se propone nada.",
  "Alle zusammenführen": "Fusionar todo",
  "Alle getrennt lassen": "Mantener todo separado",
  "Offene Entscheidungen": "Decisiones pendientes",
  "Keine offenen Entscheidungen.": "No hay decisiones pendientes.",
  "Gilt für die Oberfläche sowie für Zahlen-, Datums- und Währungsangaben.": "Se aplica a la interfaz y a los formatos de número, fecha y moneda.",

  /* Offline-Nutzung und Synchronisation */
  "Daten synchronisieren": "Sincronizar datos",
  "lokal": "local",
  "Lokale Änderungen · noch nicht übertragen": "Cambios locales · aún no transferidos",
  "Konflikt · bitte abgleichen": "Conflicto · sincroniza, por favor",
  "Stände werden verglichen …": "Comparando versiones …",
  "Beide Stände stimmen überein. Es war nichts zu übertragen.": "Ambas versiones coinciden. No había nada que transferir.",
  "Die lokalen Änderungen wurden auf den Server übertragen.": "Los cambios locales se han subido al servidor.",
  "Der Serverstand war neuer und wurde übernommen.": "La versión del servidor era más reciente y se ha adoptado.",
  "Der Server ist nicht erreichbar. Die Anwendung arbeitet mit dem lokalen Stand weiter; Änderungen bleiben auf diesem Gerät gesichert und werden beim nächsten erfolgreichen Abgleich übertragen.": "No se puede acceder al servidor. La aplicación continúa con la versión local; los cambios quedan guardados en este dispositivo y se subirán en la próxima sincronización correcta.",
  "Der Abgleich ist fehlgeschlagen.": "La sincronización ha fallado.",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Beide Stände lassen sich nicht zusammenführen, ohne dass Angaben verloren gingen — bitte einen davon auswählen. Der andere wird überschrieben.": "Tanto en este dispositivo como en el servidor se ha modificado algo desde la última sincronización. Las dos versiones no pueden combinarse sin perder datos: elige una de ellas. La otra se sobrescribirá.",
  "Dieses Gerät": "Este dispositivo",
  "Server": "Servidor",
  "Letzte Bewegung": "Último movimiento",
  "Bewegungen": "Movimientos",
  "Serverstand {v}": "Versión del servidor {v}",
  "Achtung: Dieses Gerät hat kein gefülltes Kellerbuch. „Dieses Gerät behalten“ würde den Serverstand leeren.": "Atención: este dispositivo no tiene una bodega con contenido. «Conservar este dispositivo» vaciaría la versión del servidor.",
  "Achtung: Auf dem Server liegt kein gefülltes Kellerbuch. „Server behalten“ würde den hiesigen Stand verwerfen.": "Atención: en el servidor no hay una bodega con contenido. «Conservar servidor» descartaría la versión de este dispositivo.",
  "Später entscheiden": "Decidir más tarde",
  "Server behalten": "Conservar servidor",
  "Dieses Gerät behalten": "Conservar este dispositivo",

  /* Titel der Dialoge */
  "Info": "Info",
  "Region bearbeiten": "Editar región",
  "Winzer bearbeiten": "Editar bodega",
  "Wein bearbeiten": "Editar vino",
  "Jahrgang bearbeiten": "Editar añada",
  "Kritik bearbeiten": "Editar puntuación",
  "Entnahme": "Salida",
  "Zugang bearbeiten": "Editar entrada",
  "Entnahme bearbeiten": "Editar salida",

  /* Etiketten offline */
  "wartet auf Übertragung": "pendiente de subir",
  "Ein wartendes Etikett wurde übertragen.": "Se ha subido una etiqueta pendiente.",
  "{n} wartende Etiketten wurden übertragen.": "Se han subido {n} etiquetas pendientes.",
  "Ein Etikett wird im Hintergrund für den Offline-Betrieb geladen.": "Se está descargando una etiqueta en segundo plano para el uso sin conexión.",
  "{n} Etiketten werden im Hintergrund für den Offline-Betrieb geladen.": "Se están descargando {n} etiquetas en segundo plano para el uso sin conexión.",
  "Ein Foto wartet auf Übertragung": "Una foto pendiente de subir",
  "{n} Fotos warten auf Übertragung": "{n} fotos pendientes de subir",
  "Wirklich löschen?": "¿Eliminar definitivamente?",
  "Bewertet": "Valorado",
  "Noch nichts erfasst. Sobald du Flaschen einlagerst, entnimmst oder eine Kritik schreibst, entsteht hier der Verlauf.": "Todavía no hay nada registrado. En cuanto guardes o retires botellas, o escribas una crítica, aquí surgirá el historial.",
  "Datum der Entnahme": "fecha de la salida",
  "Datum der zugehörigen Entnahme — die Kritik selbst ist undatiert": "Fecha de la salida correspondiente: la crítica en sí no tiene fecha",

  /* Kritik erfassen und zuordnen */
  "Nicht zugeordnet": "Sin asignar",
  "noch nicht zugeordnet": "aún sin asignar",
  "Wein zuordnen": "Asignar vino",
  "Ohne Angabe": "Sin datos",
  "Kritik zuordnen": "Asignar crítica",
  "— Wein wählen —": "— Elegir vino —",
  "＋ Neuen Wein anlegen": "＋ Crear un vino nuevo",
  "Noch nicht zuordnen": "Asignar más tarde",
  "Wein suchen oder wählen …": "Buscar o elegir un vino …",
  "Wein (Notiz)": "Vino (nota)",
  "Name des Weins": "Nombre del vino",
  "＋ Neuen Winzer anlegen": "＋ Crear una bodega nueva",
  "Name des Winzers": "Nombre de la bodega",
  "＋ Neuer Jahrgang": "＋ Nueva añada",
  "Jahr (leer = N.V.)": "Año (vacío = N.V.)",
  "Zuordnen": "Asignar",
  "Etikett fotografieren": "Fotografiar la etiqueta",
  "Anderes Bild": "Otra imagen",
  "Wird übertragen …": "Subiendo …",
  "Diese Kritik wartet noch auf ihren Wein. Wähle den passenden aus oder lege ihn neu an.": "Esta crítica todavía espera su vino. Elige el correcto o créalo.",
  "Erst der Eindruck, dann die Zuordnung: Wenn der Wein noch nicht feststeht, genügen ein Name und ein Foto des Etiketts.": "Primero la impresión, luego la asignación: si el vino aún no está claro, bastan un nombre y una foto de la etiqueta.",
  "Bitte wenigstens einen Namen oder Hinweis zum Wein angeben — sonst lässt sich die Kritik später nicht wiedererkennen.": "Indica al menos un nombre o una pista sobre el vino; de lo contrario, la crítica no podrá reconocerse después.",
  "Bitte einen Namen für den Wein angeben.": "Indica un nombre para el vino.",
  "Bitte einen Namen für den Winzer angeben.": "Indica un nombre para la bodega.",
  "Bitte eine Region für den neuen Winzer wählen.": "Elige una región para la nueva bodega.",
  "Bitte einen Wein wählen.": "Elige un vino.",
  "Bitte ein gültiges Jahr angeben oder das Feld für N.V. leer lassen.": "Indica un año válido o deja el campo vacío para N.V.",
  "Bitte den Kritiker bzw. die Quelle angeben.": "Indica el crítico o la fuente.",
  "Der Wert muss zwischen {min} und {max} liegen ({label}).": "El valor debe estar entre {min} y {max} ({label}).",
  "Dieser Jahrgang hat bereits ein Etikett — durch das neue ersetzen": "Esta añada ya tiene una etiqueta: sustituirla por la nueva",
  "z. B. „Riesling, grünes Etikett, Mosel\"": "p. ej. «Riesling, etiqueta verde, Mosela»",
  "Kein Treffer für „{q}“": "Sin resultados para «{q}»",
  "Ohne Zuordnung anlegen": "Guardar sin vino",

  /* Zusammenführen: Feldvergleich */
  "Merkmal": "Atributo",
  "gleich": "igual",
  "wird ergänzt": "se añadirá",
  "abweichend": "difiere",
  "ohne weitere Angaben": "sin más datos",
  "Rohdaten anzeigen": "Mostrar datos en bruto",
  "Rohdaten ausblenden": "Ocultar datos en bruto",
  "Keine widersprüchlichen Angaben — beim Zusammenführen bleibt alles erhalten und beide Seiten ergänzen sich.": "No hay datos contradictorios: al fusionar se conserva todo y ambas partes se complementan.",
  "Eine Angabe widerspricht sich. Sie wird vom Ziel übernommen, die der Quelle geht verloren.": "Un dato es contradictorio. Se conserva el del destino; el del origen se pierde.",
  "{n} Angaben widersprechen sich. Sie werden vom Ziel übernommen, die der Quelle gehen verloren.": "{n} datos son contradictorios. Se conservan los del destino; los del origen se pierden.",
  "Eine abweichende Angabe der Quelle geht dabei verloren.": "Se perderá un dato divergente del origen.",
  "{n} abweichende Angaben der Quelle gehen dabei verloren.": "Se perderán {n} datos divergentes del origen.",
  "Eigenes Label": "Etiqueta propia",
  "Trinkfenster ab": "Ventana de consumo desde",
  "Breite": "Latitud",
  "Länge": "Longitud",
  "＋ Neue Region anlegen": "＋ Crear una región nueva",
  "Bitte einen Namen für die neue Region angeben.": "Indica un nombre para la nueva región.",
  "Bitte gültige Koordinaten für die neue Region angeben (Dezimalgrad).": "Indica coordenadas válidas para la nueva región (grados decimales).",
  "Trinkreife ab · früh zuerst": "Ventana de consumo desde · antes primero",
  "Trinkreife ab · spät zuerst": "Ventana de consumo desde · después primero",
  "Trinkreife bis · früh zuerst": "Ventana de consumo hasta · antes primero",
  "Trinkreife bis · spät zuerst": "Ventana de consumo hasta · después primero",

  /* Altbestand freigeben */
  "Lokal geführt": "Gestionado localmente",
  "Für den Katalog freigeben": "Liberar para el catálogo",
  "{n} Region": "{n} región",
  "Wirklich {n} Eintrag freigeben?": "¿Liberar realmente {n} entrada?",
  "Wirklich {n} Einträge freigeben?": "¿Liberar realmente {n} entradas?",
  "waren beim Einführen des Katalogs bereits vorhanden. Solche Angaben werden absichtlich nicht vorgeschlagen — sonst hätte der erste Abgleich das halbe Kellerbuch auf einmal vorgelegt. Willst du sie gemeinsam pflegen, gib sie hier frei.": "ya existían cuando se introdujo el catálogo. Estos datos no se proponen a propósito; de lo contrario, la primera sincronización habría presentado media bodega de golpe. Si quieres mantenerlos en común, libéralos aquí.",
  "Winzer und Region eines Weins gehen dabei mit; ohne sie wäre der Eintrag im Katalog unbrauchbar. Liegt derselbe Wein dort schon unter anderer Kennung, entsteht ein zweiter Eintrag — dafür gibt es das Zusammenführen.": "El vino se lleva consigo su bodega y su región; sin ellas la entrada del catálogo sería inservible. Si el mismo vino ya está allí con otro identificador, aparecerá una segunda entrada: para eso está la fusión.",
  "Ein weiterer Eintrag wurde einmal abgelehnt und bleibt dauerhaft lokal.": "Otra entrada fue rechazada una vez y permanece local de forma definitiva.",
  "{n} weitere Einträge wurden einmal abgelehnt und bleiben dauerhaft lokal.": "Otras {n} entradas fueron rechazadas una vez y permanecen locales de forma definitiva.",
  "Speichern fehlgeschlagen": "Error al guardar",

  /* Nachgetragen (Prüfung tests/i18n.test.mjs) */
  "Label": "Etiqueta",
  "Wein auf der Karte suchen …": "Buscar un vino en la carta …",
  "Kein Wein auf der Karte passt zur Suche.": "Ningún vino de la carta coincide con la búsqueda.",
  "Gliederung": "Estructura",
  "Land → Region → Winzer → Weine": "País → Región → Bodega → Vinos",
  "Label → Land → Region → Winzer → Weine": "Etiqueta → País → Región → Bodega → Vinos",
  "Inhaltsverzeichnis (Länder & Regionen)": "Índice (países y regiones)",
  "Seitenzahlen": "Números de página",
  "PDF herunterladen": "Descargar PDF",
  "Suchen (Wein, Winzer, Region) …": "Buscar (vino, bodega, región) …",
  "{n} von {m} angezeigt — weiter scrollen für mehr": "{n} de {m} mostrados: sigue desplazándote para ver más",
  "Im Katalog verfügbar": "Disponible en el catálogo",
  "Aus dem Katalog übernommen:": "Tomado del catálogo:",
  "Verknüpfung mit dem Katalog": "vínculo con el catálogo",
  "pH": "pH",

  /* Kritik-Einstellungen */
  "Standard-Bewertungsschema": "Escala de puntuación predeterminada",
  "Meine Kritiken im gemeinsamen Katalog zeigen": "Mostrar mis críticas en el catálogo común",
  "Bewertung, Kritiker, Anlass, Speisenbegleitung und Verkostungsnotiz sind für alle Konten sichtbar, zusammen mit deinem Benutzernamen. Bestände, Lagerorte und Preise niemals.": "La puntuación, el crítico, la ocasión, el maridaje y la nota de cata son visibles para todas las cuentas, junto con tu nombre de usuario. Las existencias, ubicaciones y precios nunca lo son.",
  "Deine Kritiken bleiben in deinem Kellerbuch und erscheinen bei keinem anderen Konto.": "Tus críticas permanecen en tu bodega y no aparecen en ninguna otra cuenta.",
  "Gespeichert.": "Guardado.",
  "Das hat nicht geklappt.": "No ha funcionado.",
  "Eigene Kritik": "Crítica propia",
  "Mein Keller": "Mi bodega",
  "Suchbereich": "Ámbito de búsqueda",
  "geteilt": "compartida",
  "Suche löschen": "Borrar búsqueda",
  "Umfang der Listen": "Alcance de las listas",
  "Anzeigen": "Mostrar",
  "Keller mit Bestand": "Bodega con existencias",
  "Gesamter Keller": "Bodega completa",
  "Nur eigene Kritiken zeigen": "Mostrar solo mis críticas",
  "Alle Kritiken einblenden (eine weitere)": "Mostrar todas las críticas (una más)",
  "Alle Kritiken einblenden ({n} weitere)": "Mostrar todas las críticas ({n} más)",
  "Du hast diesen Wein noch nicht bewertet.": "Todavía no has valorado este vino.",
  "Im gemeinsamen Katalog zeigen": "Mostrar en el catálogo común",
  "Bewertung, Kritiker, Anlass, Pairing und Notiz sind für alle Konten sichtbar — samt deinem Benutzernamen. Bestände, Lagerorte und Preise niemals.": "La puntuación, el crítico, la ocasión, el maridaje y la nota son visibles para todas las cuentas, junto con tu nombre de usuario. Las existencias, ubicaciones y precios nunca.",
  "Deine Kritiken bleiben in deinem Kellerbuch.": "Tus críticas permanecen en tu bodega.",
  "Bewertung, Kritiker, Speisenbegleitung und Notiz sind für alle Konten sichtbar — samt deinem Benutzernamen. Der Anlass bleibt privat, ebenso Bestände, Lagerorte und Preise.": "La puntuación, el crítico, el maridaje y la nota son visibles para todas las cuentas, junto con tu nombre de usuario. La ocasión queda privada, igual que existencias, ubicaciones y precios.",

  /* Jahrgänge mit ähnlicher Witterung */
  "Jahrgänge mit ähnlicher Witterung in {region}": "Añadas con un tiempo similar en {region}",
  "sehr ähnlich": "muy similar",
  "gut vergleichbar": "bien comparable",
  "in Teilen ähnlich": "parcialmente similar",
  "gering ähnlich": "poco similar",
  "nahezu deckungsgleich": "casi idéntica",
  "wärmer": "más cálida",
  "später reif": "más tarde en madurar",
  "früher reif": "antes en madurar",
  "Tage": "días",
  "kühler": "más fresca",
  "nasser": "más lluviosa",
  "trockener": "más seca",
  "sonniger": "más soleada",
  "trüber": "más nublada",
  "Bodenwasser Periodenende": "Agua del suelo al final del periodo",

  /* Witterung: Abruf und Kennzahlen im Vergleich */
  "Witterung abrufen": "Obtener datos meteorológicos",
  "Neu abrufen": "Volver a obtener",
  "Abrufen": "Obtener",
  "Klimareihe laden": "Cargar serie climática",
  "Klimareihe aktualisieren": "Actualizar serie climática",
  "Klimareihe wird geladen …": "Cargando serie climática …",
  "Ø letzte 10 Jahre": "Ø últimos 10 años",
  "Ø alle Jahre": "Ø todos los años",
  "Ø Temperatur": "Ø temperatura",
  "Ø Höchsttemperatur": "Ø temperatura máxima",
  "Ø Tiefsttemperatur": "Ø temperatura mínima",
  "Sonnenstunden": "Horas de sol",
  "Gradtage (Basis 10 °C)": "Grados-día (base 10 °C)",
  "Hitzetage ≥ 30 °C": "Días de calor ≥ 30 °C",
  "Jahrgang {jahr} ist abgeschlossen, fehlt aber noch in der geladenen Klimareihe — „Klimareihe aktualisieren“ nimmt ihn in Vergleich und Stilprofil auf.": "La añada {jahr} está cerrada, pero aún falta en la serie climática cargada: «Actualizar serie climática» la incorpora a la comparativa y al perfil de estilo.",
  "Reiferegen noch hochgerechnet — die Tage nach der Reife liegen jetzt im Archiv. „Klimareihe aktualisieren“ ersetzt die Schätzung.": "Lluvia de maduración aún extrapolada: los días posteriores a la madurez ya están en el archivo. «Actualizar serie climática» sustituye la estimación.",
  "Reiferegen noch hochgerechnet — die Tage nach der Reife fehlen im Archiv. Ab {datum} „Klimareihe aktualisieren“.": "Lluvia de maduración aún extrapolada: los días posteriores a la madurez todavía no están en el archivo. A partir del {datum}, pulse «Actualizar serie climática».",
  "Diese Klimareihe stammt aus einer älteren Fassung — einmal „Klimareihe aktualisieren“, damit Vergleich und Stilprofil neu gerechnet werden.": "Esta serie climática procede de una versión anterior: pulse una vez «Actualizar serie climática» para que la comparativa y el perfil de estilo se recalculen.",

  /* Stilprofil */
  "Stilprofil {jahr}": "Perfil de estilo {jahr}",
  "Reife geschätzt: {datum}": "Madurez estimada: {datum}",
  "im Mittel der Region: {datum}": "media de la región: {datum}",
  "Wärme": "Calor",
  "Nächte in der Reife": "Noches en la maduración",
  "Regen in der Reife": "Lluvia en la maduración",
  "Bodenwasser am Ende": "Agua del suelo al final",
  "Bodenwasser zur Reife": "Agua del suelo en la madurez",
  "sehr kühl": "muy fresca",
  "kühl": "fresca",
  "typisch": "típica",
  "warm": "cálida",
  "sehr warm": "muy cálida",
  "mild": "suaves",
  "sehr mild": "muy suaves",
  "sehr trocken": "muy seca",
  "trocken": "seca",
  "feucht": "húmeda",
  "sehr nass": "muy lluviosa",
  "ausgetrocknet": "agotada",
  "knapp": "escasa",
  "reichlich": "abundante",
  "sehr reichlich": "muy abundante",
  "Hitzejahr: opulent und alkoholreich, die Säure wird knapp": "Año de calor: opulento y alcohólico, la acidez escasea",
  "Reife mit Frische: warme Tage, kühle Nächte — volle Reife bei erhaltener Säure": "Madurez con frescura: días cálidos, noches frescas — plena madurez con la acidez preservada",
  "Kühl und nass: schlank, säurebetont, stark von der Selektion abhängig": "Fresco y lluvioso: ligero, de acidez marcada, muy dependiente de la selección",
  "Volle Reife, mehr Körper und Alkohol, weichere Säure": "Madurez plena, más cuerpo y alcohol, acidez más suave",
  "Schlank und säurebetont, eher niedriger Alkohol": "Ligero y de acidez marcada, alcohol más bien bajo",
  "Kühle Nächte bewahren Frische, Aromatik und Farbe": "Las noches frescas conservan frescura, aromas y color",
  "Milde Nächte: weichere Frucht, Aromatik eher reif als frisch": "Noches suaves: fruta más blanda, aromas más maduros que frescos",
  "Regen zur Reife: Verdünnungs- und Fäulnisgefahr": "Lluvia en la maduración: riesgo de dilución y podredumbre",
  "Trockene Reife: gesundes Lesegut": "Maduración seca: uva sana",
  "Trockenstress: kleine Beeren, dicke Schalen, Konzentration und Tannin": "Estrés hídrico: bayas pequeñas, hollejos gruesos, concentración y tanino",
  "Gute Wasserversorgung: größere Beeren, zugänglicher Stil": "Buen suministro de agua: bayas más grandes, estilo más accesible",
  "Ein für die Region typischer Jahrgang ohne ausgeprägte Richtung": "Una añada típica de la región sin una dirección marcada",
  /* Katalogabgleich: Vorschläge, Änderungen, Sync-Bericht */
  "(ohne Namen)": "(sin nombre)",
  "Ablehnen (+{n} abhängige)": "Rechazar (+{n} dependientes)",
  "Angenommene Vorschläge gehen in den Katalog und stehen allen Cloud-Konten zur Verfügung. Übernommen wird nur, was der Vorschlag ändert; fehlende Winzer und Regionen gehen mit, wenn sie selbst vorgeschlagen sind. Eine abgelehnte Aufnahme bleibt beim Vorschlagenden dauerhaft lokal, eine abgelehnte Änderung nur in dieser Fassung.": "Las propuestas aceptadas pasan al catálogo y están disponibles para todas las cuentas en la nube. Solo se aplica lo que cambia la propuesta; los bodegueros y regiones que faltan se incluyen si también han sido propuestos. Una alta rechazada queda local para siempre en quien la propuso; un cambio rechazado, solo en esa versión.",
  "Dein Eintrag wird auf die Katalogfassung zurückgesetzt. Bestände, Lagerorte und Preise bleiben.": "Tu entrada vuelve a la versión del catálogo. Existencias, ubicaciones y precios se mantienen.",
  "Deine Fassung bleibt bei dir stehen; der Eintrag bleibt mit dem Katalog verbunden und bekommt weitere Änderungen mit.": "Tu versión se queda contigo; la entrada sigue vinculada al catálogo y recibe los cambios posteriores.",
  "Deine Fassung → Katalogfassung": "Tu versión → versión del catálogo",
  "Der Eintrag steht nicht mehr im Katalog — vermutlich wurde er zusammengeführt. Annehmen ist nicht möglich.": "La entrada ya no está en el catálogo; probablemente se fusionó. No se puede aceptar.",
  "Der Eintrag wird danach nur bei dir geführt. Unter „Lokal geführt“ kannst du ihn später wieder freigeben.": "Después la entrada solo se lleva en tu bodega. Puedes volver a liberarla más tarde en «Gestionado localmente».",
  "Der Katalog war nicht erreichbar; das holt der nächste Abgleich nach.": "No se pudo acceder al catálogo; la próxima sincronización lo recuperará.",
  "Der Katalog wurde seit dem Vorschlag geändert, aber an anderen Stellen. Angenommen wird nur, was dieser Vorschlag ändert.": "El catálogo ha cambiado desde la propuesta, pero en otros puntos. Solo se acepta lo que cambia esta propuesta.",
  "Der Katalog wurde seit dem Vorschlag geändert. Markierte Felder hat auch jemand anderes geändert — beim Annehmen gilt dieser Vorschlag.": "El catálogo ha cambiado desde la propuesta. Otra persona también cambió los campos marcados; al aceptar se aplica esta propuesta.",
  "Diese Einträge verweisen auf einen Winzer oder eine Region, die nur bei dir geführt werden. Im Katalog wären sie unbrauchbar — gib den Bezug unten unter „Lokal geführt“ frei, dann gehen sie beim nächsten Abgleich mit.": "Estas entradas remiten a un bodeguero o a una región que solo se llevan en tu bodega. En el catálogo serían inservibles: libera la referencia abajo en «Gestionado localmente» y se incluirán en la próxima sincronización.",
  "Ein Eintrag im Katalog zusammengeführt.": "Una entrada del catálogo fusionada.",
  "{n} Einträge im Katalog zusammengeführt.": "{n} entradas del catálogo fusionadas.",
  "Ein Vorschlag wurde abgelehnt.": "Se rechazó una propuesta.",
  "{n} Vorschläge wurden abgelehnt.": "Se rechazaron {n} propuestas.",
  "Ein Vorschlag wurde angenommen.": "Se aceptó una propuesta.",
  "{n} Vorschläge wurden angenommen.": "Se aceptaron {n} propuestas.",
  "Ein neuer Vorschlag ging an den Verwalter.": "Una nueva propuesta se envió al administrador.",
  "{n} neue Vorschläge gingen an den Verwalter.": "Se enviaron {n} propuestas nuevas al administrador.",
  "Eine Katalogänderung weicht von deiner Fassung ab — siehe Katalog → Änderungen.": "Un cambio del catálogo difiere de tu versión; consulta Catálogo → Cambios.",
  "{n} Katalogänderungen weichen von deiner Fassung ab — siehe Katalog → Änderungen.": "{n} cambios del catálogo difieren de tu versión; consulta Catálogo → Cambios.",
  "Eine Katalogänderung übernommen.": "Se aplicó un cambio del catálogo.",
  "{n} Katalogänderungen übernommen.": "Se aplicaron {n} cambios del catálogo.",
  "Hängt an einem abgelehnten Winzer oder einer abgelehnten Region.": "Depende de un bodeguero o una región rechazados.",
  "Im Katalog wurden zwei Einträge vereint — deine Bestände und Verweise sind mitgewandert.": "Se unieron dos entradas del catálogo; tus existencias y referencias se han trasladado.",
  "In Prüfung": "En revisión",
  "in Prüfung": "en revisión",
  "Jahrgang entfernt": "añada eliminada",
  "neuer Jahrgang": "nueva añada",
  "Katalog befüllt": "catálogo rellenado",
  "Katalog wird abgeglichen …": "Sincronizando el catálogo …",
  "Katalog: nichts Neues.": "Catálogo: nada nuevo.",
  "Katalogfassung wiederherstellen": "Restaurar la versión del catálogo",
  "Keine inhaltliche Änderung erkennbar.": "No se aprecia ningún cambio de contenido.",
  "Korrektur verwerfen": "Descartar la corrección",
  "Korrigieren": "Corregir",
  "Mit Korrektur annehmen": "Aceptar con corrección",
  "Laden fehlgeschlagen.": "Error al cargar.",
  "Legst du im Cloud-Modus einen Wein, Winzer oder eine Region an oder änderst etwas daran, wird das dem Verwalter des Katalogs vorgelegt. Bis zur Entscheidung arbeitest du ungehindert mit deiner eigenen Fassung weiter.": "Si en el modo nube creas o modificas un vino, un bodeguero o una región, se presenta al administrador del catálogo. Hasta la decisión sigues trabajando sin trabas con tu propia versión.",
  "Meine behalten": "Conservar la mía",
  "Nichts zu entscheiden.": "Nada que decidir.",
  "Wirklich zurückziehen?": "¿Retirar de verdad?",
  "Zu entscheiden": "Por decidir",
  "Zuletzt eingespielt": "Aplicado recientemente",
  "Zurückgehalten": "Retenidos",
  "Zurückziehen": "Retirar",
  "auch im Katalog geändert": "también cambiado en el catálogo",
  "davon {n} als Bezug mitgenommen": "de ellas, {n} incluidas como referencia",
  "davon {n} als Folge": "de ellas, {n} como consecuencia",
  "durch {n}": "por {n}",
  "von {n}": "de {n}",
  "entfernt": "eliminado",
  "geändert": "modificado",
  "neu aufgenommen": "incorporado",
  "neu": "nuevo",
  "unbekannt": "desconocido",
  "veraltet": "desactualizado",
  "vorhanden": "presente",
  "werden nur bei dir geführt — weil sie beim Einführen des Katalogs schon vorhanden waren oder weil du einen Vorschlag zurückgezogen hast. Solche Angaben werden nicht vorgeschlagen. Willst du sie gemeinsam pflegen, gib sie hier frei.": "solo se llevan en tu bodega, porque ya existían al introducirse el catálogo o porque retiraste una propuesta. Estos datos no se proponen. Si quieres mantenerlos en común, libéralos aquí.",
  "zusammengeführt": "fusionado",
  "{n} abgelehnt": "{n} rechazadas",
  "{n} angenommen": "{n} aceptadas",
  "{typ} „{name}“ fehlt im Katalog und wartet nicht als Vorschlag — so nicht annehmbar.": "{typ} «{name}» no está en el catálogo ni espera como propuesta; así no se puede aceptar.",
  "{typ} „{name}“ wartet selbst auf Prüfung und wird beim Annehmen mitgenommen.": "{typ} «{name}» también espera revisión y se incluirá al aceptar.",
  "Änderungen am gemeinsamen Katalog, die deine Weine, Winzer oder Regionen betreffen. Wo deine Fassung noch dem alten Stand entsprach, wurde still nachgezogen. Bestände, Lagerorte und Preise bleiben immer unberührt.": "Cambios en el catálogo común que afectan a tus vinos, bodegueros o regiones. Donde tu versión aún coincidía con el estado anterior, se actualizó sin más. Existencias, ubicaciones y precios no se tocan nunca.",
  "Beschreibung": "Descripción",
  "angenommen": "aceptado",
  "abgelehnt": "rechazado",
  "Aufnahme": "Alta",
  "Änderung": "Cambio",
  "übernommen": "aplicado",
  "lokal geführt": "gestionado localmente",
  "bereits aktuell": "ya actualizado",
  /* Katalogabgleich: Aufnahme mit eigener Fassung */
  "deine Fassung bleibt": "tu versión se mantiene",
  "Du hast seit deinem Vorschlag weiter daran gearbeitet. Deine neuere Fassung bleibt und geht als Änderung an den Verwalter.": "Seguiste trabajando en ello después de tu propuesta. Tu versión más reciente se mantiene y se envía al administrador como cambio.",
  /* Katalogabgleich: Dreiwegevergleich */
  "Hier hat der Katalog ein Feld geändert, das du selbst anders geändert hast. Alles Übrige ist bereits übernommen. „Meine behalten“ lässt deine Angabe stehen; sie geht dann als Änderungsvorschlag an den Verwalter.": "Aquí el catálogo cambió un campo que tú cambiaste de otra manera. Todo lo demás ya se ha aplicado. «Conservar la mía» deja tu dato; entonces se envía al administrador como propuesta de cambio.",
  /* Kellerbuch-Abgleich: Zusammenführen */
  "Auf beiden Seiten gab es Änderungen. Sie widersprachen sich nicht und wurden zusammengeführt.": "Hubo cambios en ambos lados. No se contradecían y se han combinado.",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Alles, was sich nicht widerspricht, wird zusammengeführt. An diesen Stellen haben beide Seiten dasselbe verschieden geändert:": "Desde la última sincronización se ha cambiado algo tanto en este dispositivo como en el servidor. Todo lo que no se contradice se combina. En estos puntos ambos lados cambiaron lo mismo de forma distinta:",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Ohne gemeinsamen Ausgangsstand lassen sich beide nicht sicher zusammenführen — bitte einen davon auswählen. Der andere wird überschrieben.": "Desde la última sincronización se ha cambiado algo tanto en este dispositivo como en el servidor. Sin un punto de partida común no se pueden combinar con seguridad; elige uno. El otro se sobrescribirá.",
  "Bestand {g}": "Existencias {g}",
  "Ein Stand wird ganz übernommen, der andere überschrieben — auch dort, wo sich nichts widerspricht.": "Se adopta una versión completa y la otra se sobrescribe, incluso donde nada se contradice.",
  "Ein Widerspruch · Serverstand {v}": "Una contradicción · versión del servidor {v}",
  "{n} Widersprüche · Serverstand {v}": "{n} contradicciones · versión del servidor {v}",
  "Stattdessen einen Stand ganz übernehmen": "En su lugar, adoptar una versión completa",
  "Von diesem Gerät: {a} · vom Server: {b}": "De este dispositivo: {a} · del servidor: {b}",
  "Zusammenführen, Server gilt": "Combinar, gana el servidor",
  "Zusammenführen, dieses Gerät gilt": "Combinar, gana este dispositivo",
  "gelöscht": "eliminado",
  "ja": "sí",
  "nein": "no",
  "nur auf dem Server": "solo en el servidor",
  "nur hier": "solo aquí",
  "verschieden": "distinto",
  "… und {n} weitere": "… y {n} más",
  "Beide Stände wurden zusammengeführt; beim einen Widerspruch gilt der Server.": "Se combinaron ambas versiones; en la única contradicción gana el servidor.",
  "Beide Stände wurden zusammengeführt; beim einen Widerspruch gilt dieses Gerät.": "Se combinaron ambas versiones; en la única contradicción gana este dispositivo.",
  "Beide Stände wurden zusammengeführt; bei {n} Widersprüchen gilt der Server.": "Se combinaron ambas versiones; en {n} contradicciones gana el servidor.",
  "Beide Stände wurden zusammengeführt; bei {n} Widersprüchen gilt dieses Gerät.": "Se combinaron ambas versiones; en {n} contradicciones gana este dispositivo.",
  "Bewegung": "Movimiento",
  "Einstellung": "Ajuste",
  "Katalogabweichung": "Diferencia con el catálogo",
  "Favorit": "Favorito",
  "Trinkreife ab": "Lista para beber desde",
  "Trinkreife bis": "Lista para beber hasta",
  "Dieses Gerät hat lange nicht abgeglichen — ein Teil des Katalogprotokolls liegt nicht mehr vor. Was von der Katalogfassung abweicht, steht zur Entscheidung unter Katalog → Änderungen, statt als Vorschlag gesendet zu werden.": "Este dispositivo no se ha sincronizado desde hace mucho — parte del registro del catálogo ya no está disponible. Lo que difiere de la versión del catálogo aparece para que decidas en Catálogo → Cambios, en lugar de enviarse como propuesta.",
  "Eine eigene Änderung ging direkt in den Katalog.": "Un cambio tuyo pasó directamente al catálogo.",
  "{n} eigene Änderungen gingen direkt in den Katalog.": "{n} cambios tuyos pasaron directamente al catálogo.",
  "Lokale Kopie konnte nicht gespeichert werden": "No se pudo guardar la copia local",
  "Alle von {n} annehmen (ohne {k} mit Dublettenverdacht)": "Aceptar todo de {n} (sin {k} posibles duplicados)",
  "Ein Vorschlag mit Dublettenverdacht bleibt zur Einzelprüfung offen.": "Una propuesta con sospecha de duplicado queda abierta para revisión individual.",
  "{n} Vorschläge mit Dublettenverdacht bleiben zur Einzelprüfung offen.": "{n} propuestas con sospecha de duplicado quedan abiertas para revisión individual.",
  "Mit Korrektur trotzdem neu aufnehmen": "Añadir como nuevo de todos modos, con corrección",
  "Mit „{name}“ zusammenführen": "Fusionar con «{name}»",
  "Trotzdem neu aufnehmen": "Añadir como nuevo de todos modos",
  "möglich": "posible",
  "wahrscheinlich Dublette": "probable duplicado",
  "wahrscheinlich dieselbe": "probablemente el mismo",
  "Alle wahrscheinlichen zusammenführen ({n})": "Fusionar todos los probables ({n})",
  "mögliche Dublette": "posible duplicado",
  "Ähnliche Einträge liegen schon im Katalog. Entscheide je Eintrag, ob zusammengeführt oder getrennt geführt wird. Eine wahrscheinliche Dublette wird bis dahin nicht vorgeschlagen, eine mögliche schon.": "Ya hay entradas similares en el catálogo. Decide en cada caso si fusionar o mantener por separado. Un duplicado probable no se propone hasta entonces; uno posible sí.",
  "Name gleich": "mismo nombre",
  "Name ähnlich": "nombre similar",
  "Lage nur bei einem": "pago solo en uno",
  "Land gleich": "mismo país",
  "Region gleich": "misma región",
  "andere Region": "otra región",
  "Ort gleich": "mismo pueblo",
  "gleicher Winzer": "mismo productor",
  "Winzer nur bei einem": "productor solo en uno",
  "Typ gleich": "mismo tipo",
  "+ {n} weitere": "+ {n} más",
  "Alle {n} zeigen": "Mostrar los {n}",
  "Weitere {n} zeigen": "Mostrar {n} más",
  "weniger": "menos",
  "{n} von {gesamt}": "{n} de {gesamt}",
  /* Mehrfachauswahl in Filtern */
  "Suchen …": "Buscar …",
  "Keine Treffer": "Sin resultados",
  /* Rundum-Etikett (3D) */
  "Rundum aufnehmen (3D)": "Captura panorámica (3D)",
  "Rundum-Etikett": "Etiqueta panorámica",
  "Ziehen dreht die Flasche · zwei Finger, Mausrad oder Doppeltippen vergrößern": "Arrastra para girar la botella · amplía con dos dedos, la rueda del ratón o un doble toque",
  "Kein Zugriff auf die Kamera. Bitte den Zugriff in den Einstellungen des Browsers erlauben.": "Sin acceso a la cámara. Permite el acceso en los ajustes del navegador.",
  "Es wurde keine Kamera gefunden.": "No se ha encontrado ninguna cámara.",
  "Die Kamera konnte nicht gestartet werden.": "No se ha podido iniciar la cámara.",
  "Die Kamera ist in diesem Browser nicht verfügbar.": "La cámara no está disponible en este navegador.",
  "Die Aufnahme ist fehlgeschlagen.": "La captura ha fallado.",
  "Der Upload ist fehlgeschlagen.": "La subida ha fallado.",
  "Etwas langsamer drehen": "Gira un poco más despacio",
  "Flasche weiterdrehen": "Sigue girando la botella",
  "Es wurde keine volle Umdrehung erkannt. Bitte die Flasche ganz herumdrehen, bis der Balken voll ist, und dabei im Umriss halten.": "No se ha detectado una vuelta completa. Gira la botella una vuelta entera hasta que la barra esté llena, manteniéndola dentro del contorno.",
  "Flasche in den Umriss stellen. Telefon ruhig halten, am besten aufgestützt.": "Coloca la botella dentro del contorno. Mantén el teléfono quieto, mejor apoyado.",
  "Flasche erkannt. Start tippen und die Flasche langsam einmal ganz herumdrehen — umgreifen ist erlaubt.": "Botella detectada. Pulsa Iniciar y gira la botella despacio una vuelta entera; puedes cambiar de mano.",
  "Wird berechnet …": "Calculando …",
  "Langsam drehen, bis der Balken voll ist": "Gira despacio hasta que la barra esté llena",
  "Flasche nicht erkannt — bitte im Umriss halten": "Botella no detectada: mantenla dentro del contorno",
  "Der Umriss der Flasche war nicht sicher zu erkennen. Hals und Kapsel folgen der gewählten Form und können verzerrt sein.": "No se ha podido detectar bien el contorno de la botella. El cuello y la cápsula siguen la forma elegida y pueden aparecer deformados.",
  "Fertig": "Listo",
  "Rundum-Etikett prüfen": "Revisar etiqueta panorámica",
  "Vorschau des Rundum-Etiketts": "Vista previa de la etiqueta panorámica",
  "Kapsellänge": "Longitud de la cápsula",
  "Die Kapselkante war nicht eindeutig zu erkennen. Bitte mit dem Regler an die Linie anpassen.": "No se ha podido detectar con claridad el borde de la cápsula. Ajusta la línea con el control deslizante.",
  "Einzelne Stellen wurden ergänzt. Langsameres Drehen ergibt ein schärferes Bild.": "Algunas zonas se han completado. Girar más despacio da una imagen más nítida.",
  "Wiederholen": "Repetir",
  "Rundum-Etikett aufnehmen": "Capturar etiqueta panorámica",
  "Flaschenform": "Forma de botella",
  "Start": "Iniciar",
  "Neu beginnen": "Empezar de nuevo",
  "Zum Drehen ziehen": "Arrastra para girar",
  "Folie": "Metal",
  "Wachs": "Lacre",
  "Schraubverschluss": "Tapón de rosca",
  "Ohne Kapsel": "Sin cápsula",
  "Bitte mindestens drei Fotos wählen, besser sechs rundum.": "Elige al menos tres fotos; mejor seis alrededor de la botella.",
  "Auf Foto {n} wurde keine Flasche erkannt. Die ganze Flasche sollte aufrecht im Bild stehen.": "No se ha detectado ninguna botella en la foto {n}. La botella entera debe aparecer de pie en la imagen.",
  "Foto {n} passt zu keinem anderen Foto. Zwischen zwei Fotos die Flasche nur um etwa ein Sechstel weiterdrehen.": "La foto {n} no encaja con ninguna otra. Entre dos fotos, gira la botella solo una sexta parte aproximadamente.",
  "Die Fotos zeigen die Flasche nicht von allen Seiten. Bitte rundum fotografieren, etwa alle 60°.": "Las fotos no muestran la botella por todos los lados. Fotografíala alrededor, aproximadamente cada 60°.",
  "Die Berechnung ist fehlgeschlagen.": "El cálculo ha fallado.",
  "Einzelne Stellen sind nur von der Seite zu sehen und unscharf. Mehr Fotos rundum helfen.": "Algunas zonas solo se ven de lado y están borrosas. Más fotos alrededor ayudan.",
  "Fotos aufnehmen oder auswählen — am besten sechs rundum.": "Haz o elige fotos; lo ideal son seis alrededor.",
  "Ein Foto. Mindestens drei, besser sechs.": "Una foto. Al menos tres, mejor seis.",
  "{n} Fotos. Mindestens drei, besser sechs.": "{n} fotos. Al menos tres, mejor seis.",
  "{n} Fotos. Berechnen tippen.": "{n} fotos. Toca Calcular.",
  "Flasche auf eine Fläche stellen. Gleichmäßiges Licht, kein Blitz.": "Coloca la botella sobre una superficie. Luz uniforme, sin flash.",
  "Telefon etwa auf Höhe der Flaschenmitte, die ganze Flasche im Bild.": "Sujeta el teléfono a la altura del centro de la botella, con la botella entera en la imagen.",
  "Nach jedem Foto die Flasche um etwa 60° weiterdrehen, immer in dieselbe Richtung, am Bauch angefasst (eine lose Kapsel dreht sonst mit) — sechs Fotos rundum.": "Después de cada foto gira la botella unos 60°, siempre en el mismo sentido y sujetándola por el cuerpo (si no, una cápsula suelta gira con ella): seis fotos alrededor.",
  "Foto {n}": "Foto {n}",
  "Foto {n} entfernen": "Quitar la foto {n}",
  "Foto 1 ist die Vorderseite: mit dem Vorderetikett in der Mitte beginnen. Die Fotos lassen sich durch Ziehen umsortieren.": "La foto 1 es la parte delantera: empieza con la etiqueta frontal en el centro. Arrastra las fotos para cambiar el orden.",
  "Foto {n}, Vorderseite": "Foto {n}, parte delantera",
  "Zum Verschieben ziehen oder Pfeiltasten.": "Arrastra o usa las flechas para moverla.",
  "Foto jetzt an Stelle {n}.": "Foto ahora en la posición {n}.",
  "vorne": "delante",
  "Foto aufnehmen": "Hacer foto",
  "Fotos auswählen": "Elegir fotos",
  "Aufnahmeart": "Modo de captura",
  "Video": "Vídeo",
  "Fotos": "Fotos",
  "Berechnen": "Calcular",
  "Etikettfoto zeigen": "Mostrar foto de la etiqueta",
  "3D-Ansicht zeigen": "Mostrar vista 3D",
  "Die Flasche hat die Form {form}. Die Form wurde angepasst.": "La botella tiene la forma {form}. Se ha ajustado la forma.",
};

export { texte };
